export interface AssessmentAttempt {
  attempt: number;
  status: string;
  created_at?: string | null;
  deadline?: string | null;
  status_updated_at?: string | null;
}

/** Only API-confirmed attempts determine completion. An empty list is not DONE. */
export function allAssessmentsDone(attempts: AssessmentAttempt[]): boolean {
  return attempts.length > 0 && attempts.every(attempt => attempt.status === 'DONE');
}

export function normalizeAttempts(response: unknown): AssessmentAttempt[] {
  const data = response as { results?: unknown } | null;
  const items = Array.isArray(response) ? response : data?.results;
  return Array.isArray(items)
    ? items.filter(item => item && typeof item.attempt === 'number' && typeof item.status === 'string')
      .sort((a, b) => a.attempt - b.attempt)
    : [];
}
